import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { GetFormulaCardResponse, GetFormulaCardQueryVariables } from '../types';

const getFormulaCardQuery = gql`
  query OvertimeGetFormulaCard($id: String!) {
    overtimeGetFormulaCard(id: $id) {
      code
      success
      message
      data {
        formulaCard {
          id
          name
          rateType
          rateUnit
          flatRate
          multiplier
          dailyAllowance
          formulaTemplate
          status
          createdAt
          updatedAt
          createdBy
        }
      }
    }
  }
`;

const getFormulaCard = (queryVariables: GetFormulaCardQueryVariables) => {
  return graphQLApi<GetFormulaCardResponse, GetFormulaCardQueryVariables>({
    query: getFormulaCardQuery,
    queryVariables,
  });
};

export default getFormulaCard;
